export default "__VITE_ASSET__DyA85wEY__"